// Coverage line types — FE-SCRM-015.
//
// Mirrors the BE-SCRM-006 ``CoverageLineType`` / ``QuoteStatus`` /
// ``CoverageLineOutcome`` enums + the ``sales_opportunity_coverage_line``
// row shape returned by ``GET /api/v1/sales/opportunities/{id}/coverage-lines``
// and detail endpoints. Field names match the backend serializer
// one-for-one so we don't pay a translation tax.

export const COVERAGE_LINE_TYPES = [
  "medical",
  "dental",
  "vision",
  "life",
  "std",
  "ltd",
  "voluntary",
  "eap",
  "other",
] as const;
export type CoverageLineType = (typeof COVERAGE_LINE_TYPES)[number];


export const QUOTE_STATUSES = [
  "not_started",
  "rfp_sent",
  "proposals_received",
  "presented",
  "decided",
] as const;
export type QuoteStatus = (typeof QUOTE_STATUSES)[number];


export const COVERAGE_LINE_OUTCOMES = [
  "pending",
  "won",
  "lost",
  "not_pursued",
] as const;
export type CoverageLineOutcome = (typeof COVERAGE_LINE_OUTCOMES)[number];


export interface CoverageLine {
  coverage_line_id: string;
  opportunity_id: string;
  line_type: CoverageLineType | string;
  current_carrier: string | null;
  current_premium_annualized_cents: number | null;
  current_lives_covered: number | null;
  target_carriers: string[];
  quote_status: QuoteStatus | string;
  outcome: CoverageLineOutcome | string;
  /** Always NULL except when ``outcome === "won"``. The BE check
   * constraint enforces this; the UI mirrors the rule by hiding the
   * field unless the outcome is won. */
  outcome_carrier: string | null;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
}


export interface CoverageLineListResponse {
  rows: CoverageLine[];
  total: number;
}


export interface AddCoverageLineInput {
  line_type: CoverageLineType;
  current_carrier?: string | null;
  current_premium_annualized_cents?: number | null;
  current_lives_covered?: number | null;
  target_carriers?: string[];
  quote_status?: QuoteStatus;
  outcome?: CoverageLineOutcome;
  outcome_carrier?: string | null;
  notes?: string | null;
}


export interface UpdateCoverageLineInput {
  line_type?: CoverageLineType;
  current_carrier?: string | null;
  current_premium_annualized_cents?: number | null;
  current_lives_covered?: number | null;
  target_carriers?: string[];
  quote_status?: QuoteStatus;
  outcome?: CoverageLineOutcome;
  outcome_carrier?: string | null;
  notes?: string | null;
}
